import { PortfolioModel } from '../../../portfolios/shared/models/portfolio-model';
import { CustomerContractModel } from './customer-contract-model';
import { formatDate, toDate } from '../../../shared/value-utils';
import { Locality } from '../../../shared/models/locality.model';
import { Serializable } from '../../../core/models/serializable';
import { CustomerAgentDetailsModel } from '../../shared/models/customer-agent-details-model';
import { CustomerLocationModel } from '../../shared/models/customer-location-model';
import { CustomerAccountDetailsModel } from '../../shared/models/customer-account-details-model';
import { CustomerEventModel } from './customer-event-model';
import { CustomerBrandingViewModel } from './customer-branding-view-model';
import { AdvancedIndustry } from '@admin/shared/models/industry.model';
export class CustomerModel implements Serializable<CustomerModel> {
  fromObject(obj: any): CustomerModel {
    Object.assign(this, obj);
    this.accountDetails = null;
    this.locality = null;
    this.agentList = [];
    this.locationList = [];
    this.industries = [];
    this.industryIdList = [];
    this.industryNameList = [];
    this.customerContracts = [];
    this.customerPortfolio = null;
    this.events = [];
    this.customerBranding = null;

    if (obj.accountDetails != null) {
      let t = new CustomerAccountDetailsModel();
      t = t.fromObject(obj.accountDetails);
      this.accountDetails = t;
    }

    if (obj.customerPortfolio != null) {
      let t = new PortfolioModel();
      t = t.fromObject(obj.customerPortfolio);
      this.customerPortfolio = t;
    }

    if (obj.customerBranding != null) {
      let t = new CustomerBrandingViewModel();
      t = t.fromObject(obj.customerBranding);
      this.customerBranding = t;
    }

    if (obj.locality != null) {
      let t = new Locality();
      t = t.fromObject(obj.locality);
      this.locality = t;
    }

    if (obj.agentList && obj.agentList.length && obj.agentList.length > 0) {
      obj.agentList.forEach((a) => {
        let t = new CustomerAgentDetailsModel();
        t = t.fromObject(a);
        this.agentList.push(t);
      });
    }

    if (
      obj.industryIdList &&
      obj.industryIdList.length &&
      obj.industryIdList.length > 0
    ) {
      obj.industryIdList.forEach((a) => {
        this.industryIdList.push(a);
      });
    }

    if (obj.industries && obj.industries.length && obj.industries.length > 0) {
      obj.industries.forEach((a) => {
        this.industries.push(a);
      });
    }

    if (
      obj.industryNameList &&
      obj.industryNameList.length &&
      obj.industryNameList.length > 0
    ) {
      obj.industryNameList.forEach((a) => {
        this.industryNameList.push(a);
      });
    }

    if (
      obj.locationList &&
      obj.locationList.length &&
      obj.locationList.length > 0
    ) {
      obj.locationList.forEach((l) => {
        let t = new CustomerLocationModel();
        t = t.fromObject(l);
        this.locationList.push(t);
      });
    }

    if (
      obj.customerContracts &&
      obj.customerContracts.length &&
      obj.customerContracts.length > 0
    ) {
      obj.customerContracts.forEach((l) => {
        let t = new CustomerContractModel();
        t = t.fromObject(l);
        this.customerContracts.push(t);
      });
    }

    if (obj.events && obj.events.length && obj.events.length > 0) {
      obj.events.forEach((e) => {
        let t = new CustomerEventModel();
        t = t.fromObject(e);
        this.events.push(t);
      });
    }

    return this;
  }
  toObject() {
    let result = {
      CustomerId: this.customerId,
      Name: this.name && this.name.trim(),
      Name2: this.name2 && this.name2.trim(),
      StatusId: this.statusId,
      CustomerTypeId: this.customerTypeId,
      CustomerFeedTypeId: this.customerFeedTypeId,
      CustomerFeedTypeName: this.customerFeedTypeName,
      PublicEmail: this.publicEmail,
      Website: this.website,
      NumberOfEmployeesId: this.numberOfEmployeesId,
      IndustryId: this.industryId,
      Locality: this.locality && this.locality.toObject(),
      IdNumber: this.idNumber,
      IndustryList: this.industries.map((v) => v.industryId),
      LegalName: this.legalName && this.legalName.trim(),
      LegalAddress: this.legalAddress && this.legalAddress.trim(),
      Description: this.description && encodeURI(this.description),
      LogoHref: this.logoHref,
      LogoThumbnailHref: this.logoThumbnailHref,
      RegistrationDate: this.registrationDate,
      ApprovalDate: this.approvalDate,
      IsVerified: this.isVerified,
      VerificationExpireDate: this.verificationExpireDate,
      VideoUrl: this.videoUrl,
      HasFeeds: this.hasFeeds,
      AccountDetails: this.accountDetails.toObject(),
      AgentList: this.agentList.map((agent) => agent.toObject()),
      LocationList: this.locationList.map((location) => location.toObject()),
      CustomerPortfolio:
        this.customerPortfolio && this.customerPortfolio.toObject(),
      Manager: this.manager,
      Portfolio: this.portfolio,
      LegacyContactInfo: this.legacyContactInfo,
      BustomerBranding: this.customerBranding,
      Location: this.location,
    };
    return result;
  }

  public customerId: number;
  public name: string;
  public name2: string;
  public statusId: number;
  public statusName: string;
  public customerTypeId: number;
  public customerTypeName: string;
  public customerFeedTypeName: string;
  public customerFeedTypeId: number;
  public publicEmail: string;
  public website: string;
  public numberOfEmployeesId: number;
  public numberOfEmployees: string;
  public industryId: number;
  public industryName: string;
  public industryNameList: string[];
  public industries: AdvancedIndustry[];
  public locality: Locality;
  public idNumber: string;
  public legalName: string;
  public legalAddress: string;
  public description: string;
  public logoHref: string;
  public logoThumbnailHref: string;
  public registrationDate: Date;
  public approvalDate: Date;
  public activationLink: string;
  public isVerified: boolean;
  public verificationExpireDate: Date;
  public videoUrl: string;
  public hasFeeds: boolean;
  public accountDetails: CustomerAccountDetailsModel;
  public agentList: CustomerAgentDetailsModel[];
  public locationList: CustomerLocationModel[];
  public customerContracts: CustomerContractModel[];
  public events: CustomerEventModel[];
  public customerPortfolio: PortfolioModel;
  public industryIdList: AdvancedIndustry[];

  public legacyContactInfo: string;

  public portfolio: string;
  public manager: string;

  public customerBranding: CustomerBrandingViewModel;

  public location: string;
  public hasPendingChanges: boolean;

  constructor() {
    this.accountDetails = new CustomerAccountDetailsModel();
    this.customerPortfolio = new PortfolioModel();
    this.agentList = [];
    this.locationList = [];
    this.customerContracts = [];
    this.events = [];
    this.industryIdList = [];
    this.customerBranding = new CustomerBrandingViewModel();
  }
}
